import { useEffect, useState } from "react";
import Footer from "../../components/Footer";
import SubHeader from "../../components/SubHeader";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { setGameMode, setPlayerView, setTargets, setTimeAndDay } from "../../store/gameSlice";
import { GameModeEnum } from "../../types/gameModeEnum";
import useWebSocket from "react-use-websocket";
import MafiaService from "../../services/mafiaService";
import { showErrorToast } from "../../store/messageSlice";
import { IPlayerView } from "../../types/IPlayerView";
import CharCard from "../../components/CharCard";
import { LynchButton } from "../../components/LynchButton";
import ConfirmPopup from "../../components/ConfirmPopup";
import RolePopup from "../../components/RolePopup";
import { setAdminRole } from "../../store/generalSlice";
import ScenarioPopup from "../../components/ScenarioPopup";
import Notifier from "../../components/Notifier";
import PlayerPreview from "../../components/PlayerPreview";

function Day() {
    const dispatch = useDispatch();
    const { serverName, playerName, role } = useSelector((state: RootState) => state.general);
    const { day, time, playerView, readMessages } = useSelector((state: RootState) => state.game);
    const [confirmLynchPopupOpen, setConfirmLynchPopup] = useState(false);
    const [confirmEndDayPopupOpen, setConfirmEndDayPopup] = useState(false);
    const [rolePopupOpen, setRolePopupOpen] = useState(false);
    const [scenarioPopupOpen, setScenarioPopupOpen] = useState(false);
    const [playerPreviewPosition, setPlayerPreviewPosition] = useState(-1);

    const { lastJsonMessage } = useWebSocket(
        `${process.env.REACT_APP_SERVER_URL}/game_time/${serverName}`,
        {
            share: false,
            shouldReconnect: () => true,
        },
    )

    useEffect(() => {
        if (process.env.REACT_APP_DEV_MODE === 'true') {
            dispatch(setTimeAndDay({ time: 69, day: 3 }));
        }
        else if (lastJsonMessage) {
            const { time_of_day, time_left, day } = lastJsonMessage;
            if (time_of_day === 'Night') {
                dispatch(setGameMode(GameModeEnum.Night));
            }
            dispatch(setTimeAndDay({ time: +time_left, day: +day }));
        }
    }, [lastJsonMessage]);

    useEffect(() => {
        pollPlayers();
        dispatch(setTargets([]));
    }, [])

    const pollPlayers = () => {
        MafiaService.PlayerView(serverName, playerName, (is_ok, payload) => {
            if (is_ok) {
                const playerView = payload as IPlayerView;
                dispatch(setPlayerView(playerView));

                if (process.env.REACT_APP_DEV_MODE === 'true') {
                    return;
                }
                if (role !== 'admin' && playerView.host_name === playerName) {
                    dispatch(setAdminRole());
                }
                if (playerView.is_dead) {
                    dispatch(setGameMode(GameModeEnum.Dead));
                }
                if (playerView.winners?.length > 0) {
                    dispatch(setGameMode(GameModeEnum.End));
                }
            } else {
                dispatch(showErrorToast(payload))
            }
        })
    }

    const getPlayers = () => {
        return <div className="players-view">
            {playerView?.other_players_state.map((p, index) => {
                return <div onClick={() => setPlayerPreviewPosition(index)} key={index}>
                    <CharCard player={p}
                        playerPosition={p.position}
                        isDead={p.is_dead}
                        key={p.position}
                    /></div>
            })}

        </div>
    }

    const confirmPopup = (confirmCallback: () => void, cancelCallback: () => void) => {
        return <div className="mafia-container-wrapper">
            <div className="mafia-container">
                <ConfirmPopup message="Are you sure?" onConfirm={confirmCallback} onCancel={cancelCallback} />
            </div>
        </div>
    }

    if (playerPreviewPosition > -1) {
        return <PlayerPreview playerPosition={playerPreviewPosition} onClose={() => setPlayerPreviewPosition(-1)} />
    }

    if (confirmLynchPopupOpen) {
        const onLynchConfirm = () => {
            MafiaService.LynchMe(serverName, playerView?.position || 0, (is_ok, payload) => {
                if (is_ok) {
                    dispatch(setGameMode(GameModeEnum.Dead));
                } else {
                    dispatch(showErrorToast(payload))
                }
            });
            setConfirmLynchPopup(false);
        }
        return confirmPopup(onLynchConfirm, () => setConfirmLynchPopup(false));
    }

    if (confirmEndDayPopupOpen) {
        return confirmPopup(() => MafiaService.EndDay(serverName), () => setConfirmEndDayPopup(false));
    }

    if (rolePopupOpen) {
        return <RolePopup role={playerView?.role_name || ''} onCancel={() => setRolePopupOpen(false)} exeTarget={playerView?.exe_target} />
    }

    if (scenarioPopupOpen) {
        return <ScenarioPopup onCancel={() => setScenarioPopupOpen(false)} />
    }

    return <div className="mafia-container-wrapper">
        <div className="mafia-container">
            <SubHeader>
                <div className="game-sub-header">
                    <div className="day">
                        Day <span>{day}</span>
                    </div>
                    <div className="time">
                        Time Left: <span>{time}</span>
                    </div>
                </div>
            </SubHeader>
            <div className="game-content">
                <div className="game-content-lynch">
                    <LynchButton onClick={() => setConfirmLynchPopup(true)} />
                </div>
                <div className="game-content-players">
                    {playerView && playerView.other_players_state?.length > 0 && getPlayers()}
                </div>
            </div>
        </div>
        <Footer>
            <button onClick={() => setScenarioPopupOpen(true)}>Info {!readMessages && <Notifier />}</button>
            <button onClick={() => setRolePopupOpen(true)}>Your Role</button>
            {role === 'admin' && <button onClick={() => setConfirmEndDayPopup(true)}>End Day</button>}
        </Footer>
    </div>
}

export default Day;